<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="header">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{header}}</h2>
          <base-tooltip-icon v-if="tooltipText" size="sm" :content="tooltipText" class="ml-2"/>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
          <div class="lg:mb-2">
            <div ref="value">
              <span id="input-two-text-dialog-value-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="requiredValidation"/>{{headerValue}}</span>
              <el-form-item prop="value">
                <el-input
                  class="w-full"
                  v-model="form.value"
                  :maxlength='maxLength'
                  :type="typeInput"
                  :rows="rowsInput"
                  aria-labelledby="input-two-text-dialog-value-label"
                >
                  <template v-if="form.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo"
                      @clear="form.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="lg:mb-2">
            <div ref="value">
              <span id="input-two-text-dialog-value2-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="requiredValidation"/>{{header2Value}}</span>
              <el-form-item prop="value2">
                <el-input
                  class="w-full"
                  v-model="form.value2"
                  :maxlength='maxLength2'
                  :type="typeInput"
                  :rows="rowsInput"
                  aria-labelledby="input-two-text-dialog-value2-label"
                >
                  <template v-if="form.value2" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo"
                      @clear="form.value2 = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="toggleDialog" class="w-full" mode="secondary-phantom-blue" :text="$t('app.cancel')" :loading="isGeneralLoading" />
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply('ruleForm')" :loading="isGeneralLoading"/>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'

export default
{
  name: 'input-text-dialog',
  components: {
    BaseDialogButton
  },
  props: {
    header: {
      type: String,
      default: 'Importante'
    },
    headerValue: {
      type: String,
      default: 'Valor'
    },
    header2Value: {
      type: String,
      default: 'Valor'
    },
    dialogOpen: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: [Number, String],
      default: -1
    },
    maxLength: {
      type: Number,
      default: 100,
    },
    maxLength2: {
      type: Number,
      default: 100,
    },
    typeInput: {
      type: String,
      default: 'text',
    },
    rowsInput: {
      type: Number,
      default: 1,
    },
    requiredValidation: {
      type: Boolean,
      default: true,
    },
    tooltipText: {
      type: String,
      default: null,
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        value: '',
        value2: '',
      },
      rules: {
        value: [
          { validator: this.isValueValid, trigger: 'blur' },
        ],
        value2: [
          { validator: this.isValueValid, trigger: 'blur' },
        ],
      }
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      this.form.value = ''
      this.form.value2 = ''
    }
  },
  mounted: async function () {
  },
  computed: {
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    role: function () {
      return this.$store.getters['auth/role'].toLowerCase()
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    }
  },
  methods: {
    isValueValid: function (rule, value, callback) {
      if (!this.requiredValidation) callback()
      if (!value) {
        return this.doAriaLiveAndReturnCallback(this.$i18n.t('validation.complete'), callback)
      } else {
        callback()
      }
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    apply: async function (ruleForm) {
      this.$refs[ruleForm].validate(async valid => {
        if (valid) {
          this.isOpen = !this.isOpen
          this.$emit('applyDialog', this.form)
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped></style>
